import { ResultOf, VariablesOf } from '@graphql-typed-document-node/core';
import { useMutation, useQueryClient } from '@tanstack/react-query';

import { useTicketingCartId, useTicketingEventId } from 'queries/tickets/utils';
import { useTicketsClient } from 'services/api';
import { CartCreateDocument, CartQuery } from 'types/api/tickets.types';

import { ticketsCartQuery } from './queries';
import { AppSyncTicketsGraphQLError } from './types';

export const useTicketsCreateCart = () => {
  const { setCartId } = useTicketingCartId();
  const { eventId } = useTicketingEventId();
  const queryClient = useQueryClient();
  const ticketsClient = useTicketsClient();

  const { isPending, isPaused, mutate } = useMutation<
    ResultOf<typeof CartCreateDocument>,
    AppSyncTicketsGraphQLError,
    VariablesOf<typeof CartCreateDocument>['input']
  >({
    mutationFn: (input) =>
      ticketsClient.request(CartCreateDocument, {
        eventId,
        input,
      }),
    retry: false,
    onSuccess: ({ cart }) => {
      if (cart?.id) {
        queryClient.setQueryData<CartQuery>(
          ticketsCartQuery({ eventId, cartId: cart.id }).queryKey,
          { cart },
        );
        setCartId(cart.id);
      }
    },
  });

  return {
    createCart: mutate,
    isLoading: isPending && !isPaused,
  };
};
